import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import {
  getPartyApi,
  getFillerAcceptedProcessStockList,
  getStockInward,
  salesOfficeOutWardStocks,
  getUnitAPI,
  getMainStockInward,
} from "api";
// import partyImage from '../../../public/images/dashboard-images/partyLogo.svg'

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";

class UserOutwardStockList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      partyId: "",
      selectedPartyDetails: null,
      partyId: "",
      factoryId: "",
      orderId: "",
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      toDate:  moment().format("YYYY-MM-DD"),
      factoryList: [],
      orderList: [],
      stockList: [],
      partyList: [],
    };
  }
  async componentDidMount() {
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    const factoryList = await getUnitAPI({
      isInternal: null,
      name: null,
      page: 1,
      limit: 10,
    });
    if (
      factoryList &&
      factoryList.data &&
      Array.isArray(factoryList.data.factories)
    ) {
      this.setState({
        factoryList: factoryList.data.factories,
      });
    }

    const jangadList = await salesOfficeOutWardStocks({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      orderId: null,
      factoryId: this.state.factoryId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      salesOfficeStatus: this.state.salesOfficeStatus,
    })
    this.setState(
      {
        orderList: jangadList.data.dataEntryOutWardStocks,
      },
    );
    this.getStockList();
  }

  getStockList() {
    const stock = salesOfficeOutWardStocks({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      orderId: this.state.orderId,
      factoryId: this.state.factoryId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      salesOfficeStatus: this.state.salesOfficeStatus,
    })
      .then(x => {
        if (x.success) {
          this.setState({
            totalSize: x.data.count,
            stockList:
              x.data.dataEntryOutWardStocks.length == 0
                ? [
                    {
                      id: "0",
                      jangad: {
                        cycle: 0,
                        weight: 0,
                        pieces: 0,
                        factory: {
                          name: "0",
                        },
                      },
                      salesOfficeOutWardStock: null,
                      mainJangad: {
                        name: "0",
                        party: {
                          name: "0",
                        },
                      },
                      stockDataEntryInWard: {
                        srNo: 0,
                        pieces: 0,
                      },
                      partyName: "0",
                      weight: 0,
                      pieces: 0,
                      cycle: 0,
                      createdAt: "",
                    },
                  ]
                : x.data.dataEntryOutWardStocks,
          });
        }
      })
      .catch(err => console.log(err));
  }

  async getFactoryList(inputValue) {
    const data = await getUnitAPI({
      isInternal: null,
      name: inputValue,
      page: null,
      limit: null,
    });
    if (data && data.data && Array.isArray(data.data.factories)) {
      this.setState({
        factoryList: data.data.factories,
      });
    }
    return this.state.factoryList.map(x => {
      return { label: x.name, value: x.id };
    });
  }
  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: inputValue,
      partyCode: null,
    });
    this.setState({
      partyList: data.data.parties,
    });
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }
  async getJangadList(inputValue) {
    const data = await salesOfficeOutWardStocks({
      page: 1,
      limit: 10,
      partyId: this.state.partyId,
      orderId: null,
      factoryId: this.state.factoryId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      salesOfficeStatus: this.state.salesOfficeStatus,
      name: inputValue
    })
    this.setState(
      {
        orderList: data.data.dataEntryOutWardStocks,
      },
    );
    if (Array.isArray(data.data.dataEntryOutWardStocks))
      return [
        { label: "All", value: "" },
        ...data.data.dataEntryOutWardStocks.map(x => {
          return { label: x.mainJangad.name, value: x.mainJangad.id };
        }),
      ];
    else return [];
  }
  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue));
        }, 0);
      });
    const promiseOptionsFactory = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getFactoryList(inputValue));
        }, 0);
      });
    const columns = [
      {
        dataField: "sr",
        text: "#",
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return (this.state.page - 1) * this.state.sizePerPage + rowIndex + 1;
        },
      },
      {
        dataField: "id",
        text: "#",
        hidden: true,
      },
      {
        dataField: "mainJangadId",
       text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad?.name;
        },
      },
      {
        dataField: "factoryId",
        text: `${this.props.t("Unit Type")}`,
        formatter: (cell, row) => {
          return row.jangad.factory?.name;
        },
      },
      {
        dataField: "party",
        text: `${this.props.t("Party Name")}`,
        formatter: (cell, row) => {
          return row.mainJangad.party?.name;
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter: (cell, row) => {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.jangad.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.jangad.weight;
        },
      },
      
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter: (cell, row) => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "viewdetails",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : row.salesOfficeOutWardStock == null ? (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/user-outward-stock",
                    query: { isEdit: 2, data: row },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
                <Link
                  to={{
                    pathname: "/user-outward-stock",
                    query: { isEdit: 3, data: row },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded ms-2">
                    <img src="images/dashboard-images/view.svg" />
                  </button>
                </Link>
              </div>
            </>
          ) : (
            <Link
              to={{
                pathname: "/user-outward-stock",
                query: { isEdit: 3, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          ),
      },

      // {
      //   dataField: "viewdetails",
      //   text: `${this.props.t("View Details")}`,
      //   formatter: (cell, row) => {
      //     return row.dataEntryOutWardStock == null ? (
      //       <>
      //         <div className="btn-group">
      //           <Link
      //             to={{
      //               pathname: "/user-outward-stock",
      //               query: { isEdit: 2, data: row },
      //             }}
      //           >
      //             <button className="py-2 px-2 border-0 rounded">
      //               <img src="images/dashboard-images/edit.svg" />
      //             </button>
      //           </Link>
      //           <Link
      //             to={{
      //               pathname: "/user-outward-stock",
      //               query: { isEdit: 3, data: row },
      //             }}
      //           >
      //             <button className="py-2 px-2 border-0 rounded ms-2">
      //               <img src="images/dashboard-images/view.svg" />
      //             </button>
      //           </Link>
      //         </div>
      //       </>
      //     ) : (
      //       <Link
      //         to={{
      //           pathname: "/user-outward-stock",
      //           query: { isEdit: 3, data: row },
      //         }}
      //       >
      //         <button className="py-2 px-2 border-0 rounded ms-2">
      //           <img src="images/dashboard-images/view.svg" />
      //         </button>
      //       </Link>
      //     );
      //   },
      // },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "manage stock";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Manage Stock - Outward Stock")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            {/* <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h3 className="text-black fw-bold">
                                  {this.props.t("Outword Stock List")}{" "}
                                </h3>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="fromDate"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  onChange={e =>
                                    this.setState(
                                      { fromDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="toDate"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  onChange={e =>
                                    this.setState(
                                      { toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Select Party")}
                                    </label>
                                    <select
                                      id="factoryId"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: "",
                                            partyId: e.target.value,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {this.state.partyList?.map((x, index) => (
                                        <option
                                          key={"1" + x.id + "1"}
                                          value={x.id}
                                        >
                                          {x.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="d-block mx-auto d-sm-inline pe-0 pe-sm-2">
                                  {" "}
                                  <input
                                    readOnly
                                    defaultValue={
                                      this.state.partyList.filter(
                                        x => x.id == this.state.partyId
                                      ).length
                                        ? this.state.partyList.filter(
                                            x => x.id == this.state.partyId
                                          )[0].contactPersonName
                                        : ""
                                    }
                                    type="text"
                                    placeholder="Contact Person"
                                    className="form-gray ps-2 mb-2 mb-md-0 py-2"
                                  />
                                </div>
                                <div className="mx-auto d-block d-sm-inline">
                                  <input
                                    readOnly
                                    defaultValue={
                                      this.state.partyList.filter(
                                        x => x.id == this.state.partyId
                                      ).length
                                        ? this.state.partyList.filter(
                                            x => x.id == this.state.partyId
                                          )[0].mobileNo1
                                        : ""
                                    }
                                    type="number" onWheel={(e) => e.target.blur()}
                                    placeholder="Mobile No."
                                    className="form-gray  py-2 ps-2"
                                  />
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Order ID")}
                                    </label>
                                    <select
                                      id="orderId"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState({
                                          orderId: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {[
                                        ...new Set(
                                          this.state.stockList.map(
                                            x => x.mainJangadId
                                          )
                                        ),
                                      ].map((x, index) => (
                                        <option key={x + index} value={x}>
                                          {x}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Status")}
                                    </label>
                                    <select
                                      id="salesOfficeStatus"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState({
                                          salesOfficeStatus: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      <option value="A">Accept</option>
                                      <option value="P">Pending</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h3 className="text-black fw-bold">
                                  {this.props.t("Office Stock List")}{" "}
                                </h3>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="fromDate"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e =>
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="toDate"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Party")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return { value: x.id, label: x.name };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="d-block mx-auto d-sm-inline pe-0 pe-sm-2">
                                  {" "}
                                  <input
                                    readOnly
                                    defaultValue={
                                      this.state.partyList.filter(
                                        x => x.id == this.state.partyId
                                      ).length
                                        ? this.state.partyList.filter(
                                            x => x.id == this.state.partyId
                                          )[0].contactPersonName
                                        : ""
                                    }
                                    type="text"
                                    placeholder="Contact Person"
                                    className="form-gray ps-2 mb-2 mb-md-0 py-2"
                                  />
                                </div>
                                <div className="mx-auto d-block d-sm-inline">
                                  <input
                                    readOnly
                                    defaultValue={
                                      this.state.partyList.filter(
                                        x => x.id == this.state.partyId
                                      ).length
                                        ? this.state.partyList.filter(
                                            x => x.id == this.state.partyId
                                          )[0].mobileNo1
                                        : ""
                                    }
                                    type="number" onWheel={(e) => e.target.blur()}
                                    placeholder="Mobile No."
                                    className="form-gray  py-2 ps-2"
                                  />
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if(e.value == "") {
                                              this.getJangadList(null)
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return { value: x.mainJangad.id, label: x.mainJangad.name };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Factory")}
                                    </label>
                                    <AsyncSelect
                                      id="factoryId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            factoryId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      
                                      loadOptions={promiseOptionsFactory}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.factoryList.map(x => {
                                          return { value: x.id, label: x.name };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    onTableChange={() => false}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}{" "}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(UserOutwardStockList);
